import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { connect } from "react-redux";
import {isNull } from "lodash";
import ShiftControl from "./ShiftControl";
import ShiftControlList from "./ShiftControlList";

const TotalShiftControlData = (props) => {
    const permissions = JSON.parse(localStorage.getItem("permissions"));

    return (
        <>
            <Tabs defaultActiveKey={!isNull(permissions) && permissions.some(p => p['sub_id'] === 58) ?
                    "AddShiftControl" : !isNull(permissions) && permissions.some(p => p['sub_id'] === 59) ?
                        "ShiftControlList" : ""} id="AddShiftControl" className="mb-3">
                <Tab eventKey="AddShiftControl" title="Add ShiftControl"
                disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 58) ? false : true}>  
                   
                   <ShiftControl />
                </Tab>
                <Tab eventKey="ShiftControlList" title="ShiftControl List"
                disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 59) ? false : true}> 
    
                  <ShiftControlList />
                </Tab>
            </Tabs>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};
const mapStateToProps = (state, ownProps) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TotalShiftControlData);